import { render, staticRenderFns } from "./InquirySuc.vue?vue&type=template&id=0abbd56c&"
import script from "./InquirySuc.vue?vue&type=script&lang=js&"
export * from "./InquirySuc.vue?vue&type=script&lang=js&"
import style0 from "./InquirySuc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports